import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgSpacingHeight02 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 3H3m18 18H3m9-3.5v-11m3 0H9m6 11H9"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSpacingHeight02)
export default ForwardRef
